import type { SharedProps } from '@bonniernews/dn-design-system-web/assets/types/shared-props.ts'

interface DirektCircleProps extends SharedProps {
  /** Hex code or supported color name */
  circleColor?: string
  isAnimated?: boolean
}

/**
 * - GitHub: [BonnierNews/dn-design-system/web/src/components/direkt-circle](https://github.com/BonnierNews/dn-design-system/tree/main/web/src/components/direkt-circle)
 * - Storybook: [DirektCircle](https://designsystem.dn.se/?path=/docs/section-subcomponents-direktcircle--docs)
 *  * The component will not include styling by itself. Make sure to include the right styles for the component. See example below:
 * `@use '@bonniernews/dn-design-system-web/components/direkt-circle/direkt-circle.scss'`
 */
export const DirektCircle = ({
  circleColor = 'white',
  classNames,
  attributes = {},
  isAnimated = false,
}: DirektCircleProps) => {
  const componentClassName = 'ds-direkt-circle'
  const animatedClassName = isAnimated ? `${componentClassName}--animated` : ''
  const circleOpacity = [
    0.25, 0.25, 0.25, 0.25, 0.25, 0.25, 0.25, 0.25, 0.24, 0.235, 0.222, 0.218, 0.212, 0.202, 0.19, 0.178, 0.165, 0.155,
    0.145, 0.135, 0.12, 0.107, 0.095, 0.083, 0.07, 0.06, 0.047, 0.035, 0.023, 0.02,
  ]

  const classes = [componentClassName, classNames, animatedClassName].filter(Boolean).join(' ')

  return (
    <svg className={classes} width='500' height='500' viewBox='-250 -250 500 500' fill='none' {...attributes}>
      <circle r='5' fill={circleColor} />
      {circleOpacity.map((opacity, index) => {
        const radius = (index + 1) * 8 + 5
        return <circle key={index} opacity={opacity} r={radius} stroke={circleColor} strokeWidth='1.5' />
      })}
    </svg>
  )
}
